import React from 'react'
import './ApiKeys.css'
import { DeleteApiKey, GetApiKeySummaries } from './domains/Foobara/Auth'
import useQuery from './domains/hooks/useQuery'
import CreateApiKeyForm from './domains/forms/Foobara/Auth/CreateApiKeyForm'

const ApiKeys: React.FC = () => {
  const { result, isLoading, setDirty } = useQuery<GetApiKeySummaries>(GetApiKeySummaries, undefined)

  function deleteApiKey (token: string): void {
    const command = new DeleteApiKey({ token })
    command.run().then(setDirty)
  }

  return (
    <div className="ApiKeys">
      <CreateApiKeyForm/>
      {isLoading
        ? (
          <p>Loading...</p>
          )
        : (
          <table>
            <thead>
              <tr>
                <th>API Key</th>
                <th>Created At</th>
                <th>Expires At</th>
                <th></th>
              </tr>
            </thead>
            <tbody>
              {result?.map((apiKeySummary) => (
                <tr key={apiKeySummary.token_id}>
                  <td>{apiKeySummary.token_id}...</td>
                  <td>{apiKeySummary.created_at?.toISOString() ?? ''}</td>
                  <td>{apiKeySummary.expires_at?.toISOString() ?? ''}</td>
                  <td><button onClick={() => { deleteApiKey(apiKeySummary.token_id) }}>Delete</button></td>
                </tr>
              ))}
            </tbody>
          </table>
          )}
    </div>
  )
}

export default ApiKeys
